import getComponent from "./getComponent.js";
const DOMParser = (self, template) => template.replace(/<#(.*?)\/>/g, (_, p1) => {
  const component = getComponent(p1.replace(/[\s\n\t]/g, ""));
  return component ? component(self) : "";
}).replace(/[\n\t]/g, "");
const MultipleParser = (self, template) => template.replace(/<#Multiple>(.*?)<#\/Multiple>/g, (_, p1) => {
  let content = "";
  for (let i = 0; i < self.correctMonths; i++) {
    content += p1;
  }
  return content;
}).replace(/[\n\t]/g, "");
export {
  DOMParser,
  MultipleParser
};
